<div class="m-5">
  <div class="section-title text-center">
    {{ "Automate Your Job Search" | translate }}
  </div>
  <div class="row mt-5 justify-content-center">
    <div class="col-12 col-md-8 my-auto p-0 order-md-1 order-2">
      <div class="number">01</div>
      <div class="description-title">
        {{ "Customize your Cv or Upload it" | translate }}
      </div>
      <div class="description">
        {{ "Our backend AI algorithms" | translate }}
      </div>

      <button class="gradient-button" routerLink="/soon">
        {{ "Customize Your CV" | translate }}
      </button>
      <button class="border-button" routerLink="/soon">
        {{ "Upload CV" | translate }}
      </button>

      <div class="text-center mt-5">
        <img class="arrow" src="../../../assets/img/arrow.png" />
      </div>
    </div>
    <img
      class="col-8 col-md-4 text-center p-0 order-md-2 order-1"
      src="../../../assets/img/automate1.png"
    />
  </div>
  <div class="row w-100 mt-5 justify-content-center">
    <div class="col-12 col-md-8 my-auto order-md-1 order-2">
      <div class="number">02</div>
      <div class="description-title">
        {{ "Customize Your Job Search" | translate }}
      </div>
      <div class="description">
        <!-- <div>
          {{ "Define your preferences" | translate }}
        </div> -->
        <div>
          <img class="hand-icon" src="../../../assets/img/hand.png" />
          {{ "Set your preferences: salary, location, job rights" | translate }}
        </div>
        <div>
          <img class="hand-icon" src="../../../assets/img/hand.png" />
          {{ "User-friendly platform tailored to your needs" | translate }}
        </div>
        <div>
          <img class="hand-icon" src="../../../assets/img/hand.png" />
          {{ "Streamlined job hunt for efficient matching" | translate }}
        </div>
        <div>
          <img class="hand-icon" src="../../../assets/img/hand.png" />
          {{ "Enhanced chances of finding the perfect job." | translate }}
        </div>
      </div>

      <button class="gradient-button" routerLink="/soon">
        {{ "Get Start" | translate }}
      </button>
    </div>
    <img
      class="col-8 col-md-4 text-center p-0 order-md-2 order-1"
      src="../../../assets/img/automate2.png"
    />
  </div>
  <div class="col-md-7 mt-5">
    <div class="number">03</div>
    <div class="description-title">
      {{ "Your Applied Jobs at a Glance" | translate }}
    </div>
    <div class="description">
      {{ "One simple dashboard to manage all job applications" | translate }}
    </div>
  </div>
  <div class="row justify-content-between">
    <app-card
      color="pink"
      img="../../../assets/img/hands-usd.png"
      title="Save 80 Hours"
      description="Active job seekers"
    />
    <app-card
      color="blue"
      img="../../../assets/img/paper.png"
      title="Custom Applications"
      description="Auto Apply crafts custom resumes"
    />

    <app-card
      color="pink"
      img="../../../assets/img/clock.png"
      title="24 hours Available"
      description="Auto Apply is here for you"
    />
    <app-card
      color="blue"
      img="../../../assets/img/bag2.png"
      title="Jobs Never Seen"
      description="Our exclusive partnership"
    />
    <app-card
      color="pink"
      img="../../../assets/img/heart.png"
      title="Creative Answers"
      description="Auto Apply leverages ChatGPT to craft"
    />
    <app-card
      color="blue"
      img="../../../assets/img/comment.png"
      title="Our people make the difference"
      description="Our support team is here to assist you"
    />
  </div>
</div>
